import React from "react";
import SEOPage from "../Components/SEOPage";
import Navbar from "../Components/Navbar";
import ScrollReveal from "../Components/ScrollReveal";
import SiteFooter from "../Components/SiteFooter";
import Chatbox from "../Components/Chatbox";
import SoftHero from "../Components/software/SoftHero";
import SoftServices from "../Components/software/SoftServices";
import SoftWhyChoose from "../Components/software/SoftWhyChoose";
import SoftTech from "../Components/software/SoftTech";
import HowWeWork from "../Components/home/HowWeWork";

// Redesigned (Tailwind) page for /software-development-services.
const SoftwarePage = () => (
  <div>
    <SEOPage
      title="Software Development Company in Noida | Custom Software Solutions | DataMetricks"
      description="DataMetricks builds scalable, secure and high-performance software: web applications, mobile apps, cloud solutions and enterprise software tailored to your business."
      canonicalUrl="https://www.datametricks.com/software-development-services"
    />

    <Navbar />
    <ScrollReveal />

    {/* Every Tailwind utility is scoped to `.tw` (see tailwind.config.js) */}
    <main className="tw">
      <SoftHero />
      <SoftServices />
      <SoftWhyChoose />
      <SoftTech />
      <HowWeWork />
    </main>

    <Chatbox />
    <SiteFooter />
  </div>
);

export default SoftwarePage;
